export default __webpack_public_path__ + "static/media/wifi.66e88c9b.png";